export default __webpack_public_path__ + "static/media/Quanterix.81ebce3a.jpeg";